/*
 * Ushuaia - forces background videos to autoplay and loop forever.
 * Targets any <video> inside a hero section, or inside an element marked [data-uh-loop].
 */
(function () {
  var SELECTOR = '[id^="shopify-section-hero_"], [data-uh-loop]';
  var tracked = [];

  function play(video) {
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function setup(video) {
    if (video.dataset.uhLooped === '1') return;
    video.dataset.uhLooped = '1';

    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('preload', 'auto');
    video.removeAttribute('controls');

    video.addEventListener('ended', function () {
      try { video.currentTime = 0; } catch (e) {}
      play(video);
    });
    video.addEventListener('pause', function () {
      if (video.dataset.uhStop === '1') return;
      window.setTimeout(function () { if (video.paused) play(video); }, 60);
    });
    video.addEventListener('loadeddata', function () { play(video); });
    video.addEventListener('canplay', function () { play(video); });
    video.addEventListener('stalled', function () { play(video); });

    tracked.push(video);
    play(video);
  }

  function hidePosters(scope) {
    var overlays = scope.querySelectorAll(
      '.deferred-media__poster, button.deferred-media__poster, .video-play-button, [aria-label*="Play" i], [aria-label*="Lecture" i], [aria-label*="Lire" i]'
    );
    Array.prototype.forEach.call(overlays, function (el) {
      if (el.closest && el.closest(SELECTOR)) el.style.display = 'none';
    });
  }

  function boot() {
    var scopes = document.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(scopes, function (scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('video'), setup);
      hidePosters(scope);
    });
  }

  function resumeAll() {
    tracked.forEach(function (v) { if (v.paused) play(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) resumeAll(); });
  window.addEventListener('pageshow', resumeAll);
  window.addEventListener('focus', resumeAll);
  ['click', 'touchstart', 'keydown', 'scroll'].forEach(function (evt) {
    window.addEventListener(evt, resumeAll, { passive: true });
  });
  window.setInterval(resumeAll, 3000);

  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; boot(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
